import React from 'react';
import './HeaderItem.css';
import { Link } from 'react-router-dom';

// Import hooka do tłumaczeń
import { useTranslation } from 'react-i18next';

const HeaderItem = (props) => { 
   
  const { t } = useTranslation();

  // Pobieramy dane, zabezpieczając subLink przed błędem w przypadku jego braku
  const { id, mainLink, subLink = [] } = props;

  return (
    <div className='nav-item' key={id}>

      {/* GŁÓWNY PRZYCISK W MENU */} 
      <div className='dropdown-menu'>
        {subLink.length > 0 ? (
          <div className='nav-btn'>
            {/* Inteligentne sprawdzanie: jeśli jest titleKey, to tłumacz. Jeśli nie, pokaż stary title */}
            {mainLink.titleKey ? t(mainLink.titleKey) : mainLink.title}
          </div>
        ) : (
          <Link className='nav-btn' to={mainLink.link}>
            {mainLink.titleKey ? t(mainLink.titleKey) : mainLink.title}
          </Link>
        )}
      </div>

      {/* ROZWIJANE PODLINKI (Dropdown Content) */}
      {subLink.length > 0 && (
        <div className='dropdown-content'>
          {subLink.map((item) => {
            return (
              <Link to={item.link} state={item.state} key={item.id}>
                {/* To samo zabezpieczenie dla rozwijanego menu */}
                {item.titleKey ? t(item.titleKey) : item.title}
              </Link>
            );
          })}
        </div>
      )}

    </div>
  );
};

export default HeaderItem;